export default __webpack_public_path__ + "assets/webgl/complete-16.55864c60.jpg";